import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import '../css/nav.css';

const Nav = () => {

  const flatListToHierarchical = (
      data = [],
      {idKey='id',parentKey='parentId',childrenKey='children'} = {}
  ) => {
      const tree = [];
      const childrenOf = {};
      data.forEach((item) => {
          const newItem = {...item};
          const { [idKey]: id, [parentKey]: parentId = 0 } = newItem;
          childrenOf[id] = childrenOf[id] || [];
          newItem[childrenKey] = childrenOf[id];
          parentId
              ? (
                  childrenOf[parentId] = childrenOf[parentId] || []
              ).push(newItem)
              : tree.push(newItem);
      });
      return tree;
  };

  const data = useStaticQuery(graphql`
    {
      wpMenu(locations: {eq: PRIMARY}) {
        count
        id
        databaseId
        name
        slug
        menuItems {
          nodes {
            id
            databaseId
            title
            url
            cssClasses
            description
            label
            linkRelationship
            target
            parentId
          }
        }
      }
    }
  `);

  let $hierarchicalList;
  if(data.wpMenu && data.wpMenu.menuItems)
    $hierarchicalList = flatListToHierarchical( data.wpMenu.menuItems.nodes );

  return (
    <ul className="main-navigation">
      { $hierarchicalList &&
        $hierarchicalList.map(
          prop => {
            var has_children ='';
            if(prop.children.length > 0){
              has_children = 'has-children';
            }

            return (
              <li
                key={prop.id}
                id={"nav-menu-item-"+prop.databaseId}
                className={has_children}
              >
                <a
                  className="nav-link"
                  href={prop.url}
                  alt={prop.label}
                >
                  {prop.label}
                </a>
                {prop.children.length > 0 &&
                  <ul className="dropdown-menu first-sub-menu">

                    {prop.children.map(child => {
                      return (
                        <li key={child.id} id={"nav-menu-item-"+prop.databaseId}>
                          <a
                            href={child.url}
                            alt={child.label}
                          >
                            {child.label}{child.children.length ? <span dangerouslySetInnerHTML={{ __html: ' &rsaquo;' }} /> : ''}
                          </a>

                          <ul className="dropdown-menu">

                            {child.children.length ? child.children.map(child => {
                              return (
                                <li key={child.id} id={"nav-menu-item-"+prop.databaseId}>
                                  <a
                                    href={child.url}
                                    alt={child.label}
                                  >
                                    {child.label}
                                  </a>
                                </li>
                              )
                            }) : ''}
                          </ul>
                        </li>
                      )
                    })}
                  </ul>
                }

              </li>
            )
          }
        )
      }
    </ul>

  )
}

export default Nav
